import { render, staticRenderFns } from "./InfoCluster.vue?vue&type=template&id=17064ef7&"
import script from "./InfoCluster.vue?vue&type=script&lang=js&"
export * from "./InfoCluster.vue?vue&type=script&lang=js&"
import style0 from "./InfoCluster.vue?vue&type=style&index=0&id=17064ef7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports